import React from 'react';
import {Provider} from 'mobx-react';
import TabBar from "../../TabBar";

import DoubleMassCurveStore from './Store/DoubleMassCurveStore';

const doubleMassCurveStore = new DoubleMassCurveStore();

class AnalysisTools extends React.Component {

  componentWillMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {

  }

  render() {
    return (
      <Provider
        doubleMassCurveStore={doubleMassCurveStore}
      >
        <div>
          <TabBar
            items={[
              {to: '/analysis/tools/double-mass-curve', label: 'Double Mass Curve'},
              {to: '/analysis/tools/staff-gauge', label: 'Staff Gauge'},
            ]}
          /><br/>
          {this.props.children}
        </div>
      </Provider>
    );
  }
}

export default AnalysisTools;


// WEBPACK FOOTER //
// ./src/components/Analysis/Tools/AnalysisTools.js